import { ENDPOINTS } from "@ea/shared_types/next/endpoints";
import { createRequest } from "../requestCreator";
import { requestTags } from "../requestTags";

export const loginUser = createRequest(ENDPOINTS.usersLogin, { public: true });
export const logoutUser = createRequest(ENDPOINTS.usersLogout);
export const refreshToken = createRequest(ENDPOINTS.oauthRefresh);

export const getUsers = createRequest(ENDPOINTS.usersGet, {
  next: { tags: [requestTags.userRequestTags.getUsers] },
});

export const getAuthenticatedUser = createRequest(ENDPOINTS.usersAuth);
export const authorizeUser = createRequest(ENDPOINTS.usersAuthorize);

export const editUser = createRequest(ENDPOINTS.usersUpdate, {
  pathCreator: (path, params) => path.replace(":id", `${params.id}`),
});

export const changePassword = createRequest(ENDPOINTS.usersChangePassword);

export const deleteUser = createRequest(ENDPOINTS.usersDelete, {
  pathCreator: (path, params) => path.replace(":id", `${params.id}`),
});

export const createUser = createRequest(ENDPOINTS.usersCreate);

export const getRoles = createRequest(ENDPOINTS.usersRolesGet);

export const getUserGroups = createRequest(ENDPOINTS.usersGroupsGet);
export const getUserGroupsCount = createRequest(ENDPOINTS.usersGroupsCount);

export const deleteUsersGroup = createRequest(ENDPOINTS.usersGroupsDelete, {
  pathCreator: (path, params) => `${path.replace(":id", `${params.id}`)}`,
});

export const createUsersGroup = createRequest(ENDPOINTS.usersGroupsCreate);

export const editUsersGroup = createRequest(ENDPOINTS.usersGroupsUpdate, {
  pathCreator: (path, params) => `${path.replace(":id", `${params.id}`)}`,
});
